<template>
  <div id="admin-paper-list">
    <!-- 试卷列表 -->
    <diy_table
      :loading="loading"
      :tipData="tipData"
      :active="active"
      :searchData="searchData"
      :buttonList="buttonList"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      @handleClickTop="handleClickTop"
      @showActive="showActive"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as paperData from "./js/paper.js";
import * as base from "../js/base.js";
export default {
  data() {
    return {
      tipData: [
        { text: "全部", key: "0" },
        { text: "未发布", key: "1" },
        { text: "已发布", key: "2" },
      ],
      loading: false,
      active: "0",
      searchData: this.$systemBaseData.getSearchData("paper"),
      buttonList: this.$systemBaseData.getTopButArray("paper"),
      tableMenu: this.$systemBaseData.getTableMenuData("paper"),
      tableData: [],
      tableButton: this.$systemBaseData.getTableButtonList("paper", ""),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempQuestion: {},
      testPaper: {}, // 整张试卷的题型分布
      testPaperEchart: {}, // 整张试卷的题型分布

      dialogData: {
        flag: false,
        title: "生成试卷",
        width: "50%",
        tempData: {},
        dialogData: [{ type: "test-paper", value: [] }],
        buttonList: [
          { text: "确定", active: "makesure_add_child_pro" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  试卷管理 23
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "23" },
        });
        this.buttonList = base.returnAllButton(
          this.buttonList,
          resultData,
          "name"
        );
        this.tableButton = base.returnAllButton(
          this.tableButton,
          resultData,
          "text"
        );
      } catch (error) {}
    },
    /**
     * 获取所有科目
     */
    async getAllSubjectForSelect() {
      try {
        let resultData = await this.$request({
          url: "/subjects/getAllSubjectForSelect",
          method: "post",
          data: null,
        });
        let option = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          option.push(dd);
        });
        this.searchData.forEach((element) => {
          if (element.key == "subject") {
            element.options = option;
          }
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 初始化表格数据
     */
    async initTable(data) {
      this.loading = true;
      try {
        setTimeout(async () => {
          let requestData = {
            status: this.active == "0" ? "" : this.active,
            currentPage: data.pageData.currentPage,
            pageSize: data.pageData.pageSize,
          };
          requestData = this.$baseData.array2json(data.searchData, requestData);
          console.log(requestData);
          let resultData = await this.$request({
            url: "/testPaper/getAllTestPaperList",
            method: "post",
            data: requestData,
          });
          this.tableData = resultData.tableData;
          this.pageData.total = resultData.total;
          this.loading = false;
        }, 500);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 搜索框旁边的按钮操作
     */
    handleClickTop(active) {
      switch (active) {
        case "create":
          // 新增试卷
          this.$router.push({
            path: "/admin/paper-index/edit",
            query: {
              id: "",
            },
          });
          break;

        default:
          break;
      }
    },
    /**
     * 表格中的按钮操作时间
     */
    async handleClick(data) {
      try {
        this.tempQuestion = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "edit_paper":
            //   编辑试卷
            console.log("编辑题库", data);
            this.$router.push({
              path: "/admin/paper-index/edit",
              query: {
                id: this.tempQuestion.id,
              },
            });
            break;
          case "delete_paper":
            //   删除试卷
            this.$confirm(
              "此操作将永久删除该试卷,若当前试卷被用于某场考试,该试卷将不可删除, 是否继续?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                try {
                  let resultData = await this.$request({
                    url: "/testPaper/deleteTestPaper",
                    method: "post",
                    data: { id: this.tempQuestion.id },
                  });
                  this.$message.success("发布成功!");
                  await this.initTable({
                    pageData: this.pageData,
                    searchData: this.searchData,
                  });
                } catch (error) {
                  this.$message.error(error.message);
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除",
                });
              });
            break;
          case "preview":
            // 预览
            await this.showTestPaperById();
            console.log(this.testPaper);
            this.dialogData.title = "查看试卷详情";
            this.dialogData.dialogData = [
              { type: "test-paper-show", value: this.testPaper },
            ];
            this.dialogData.buttonList = [
              { text: "难度分布", active: "difficulty" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 查看试卷题目分布
     */
    async showTestPaperById() {
      try {
        let resultData = await this.$request({
          url: "/testPaper/showTestPaperById",
          method: "post",
          data: { id: this.tempQuestion.id },
        });
        this.testPaper = resultData.testPaper;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 查看题型的难度分布
     */
    async examDistribution() {
      try {
        let resultData = await this.$request({
          url: "/statistics/examDistribution",
          method: "post",
          data: { paperId: this.tempQuestion.id },
        });
        let data = [];
        let xAxis = ["一星", "二星", "三星", "四星", "五星"];
        let legend = [];
        resultData.forEach((element) => {
          let dd = [0, 0, 0, 0, 0];
          element.dif.forEach((ele) => {
            dd[ele.key - 1] = ele.value;
          });
          let val = {
            name: element.type,
            type: "bar",
            // stack: "Total",
            data: dd,
          };
          legend.push(element.type);
          data.push(val);
        });
        // this.testPaper = resultData.testPaper;
        this.testPaperEchart = {
          title: "试卷难度分析图",
          xAxis: xAxis,
          legend: legend,
          yAxis: data,
        };
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 弹出框操作事件
     */
    async dialogOper(active) {
      switch (active) {
        case "difficulty":
          // 难度分布
          await this.examDistribution();
          this.dialogData.title = "查看试卷详情";
          this.dialogData.dialogData = [
            { type: "lines_paper", value: this.testPaperEchart },
          ];
          this.dialogData.buttonList = [
            { text: "试卷预览", active: "preview" },
            { text: "取消", active: "cancel" },
          ];
          break;
        case "preview":
          // 试卷预览
          await this.examDistribution();
          this.dialogData.title = "查看试卷详情";
          this.dialogData.dialogData = [
            { type: "test-paper-show", value: this.testPaper },
          ];
          this.dialogData.buttonList = [
            { text: "难度分布", active: "difficulty" },
            { text: "取消", active: "cancel" },
          ];
          break;
        case "cancel":
          this.colseDialog();
          break;

        default:
          break;
      }
    },
    /**
     * active的监听事件
     */
    showActive(data) {
      this.active = data;
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.getAllSubjectForSelect();
    await this.initTable({
      pageData: this.pageData,
      searchData: this.searchData,
    });
  },
};
</script>

<style lang="less" scoped>
#admin-paper-list {
  width: 100%;
  height: 100%;
}
</style>